import Plugin from '@ckeditor/ckeditor5-core/src/plugin';

import DeleteCitationsEditing from './deletecitationsediting';

export default class DeleteCitations extends Plugin {
  static get pluginName() {
    return 'DeleteCitations';
  }

  static get requires() {
    return [ DeleteCitationsEditing ];
  }
}
